import {LazyImage} from '../'
import Player from '../Player'

import type {LazyImageProps} from '../'

export type ResponsiveMediaType = {
  desktop?: MediaItemType
  mobile?: MediaItemType
}

export type MediaItemType = {
  type: 'image'
  image: LazyImageProps
} | {
  type: 'video'
  videoSrc: string
  thumbnail?: string
}

export interface ResponsiveMediaProps {
  media: ResponsiveMediaType
  currentScreenSize: 'desktop' | 'mobile'
  classNames?: {
    image?: string
    video?: string
  }
}

export const ResponsiveMedia = (props: ResponsiveMediaProps) => {
  const {media, currentScreenSize, classNames} = props
  const {mobile, desktop} = media

  let currentMedia: MediaItemType
  if (currentScreenSize === 'desktop' && desktop) {
    currentMedia = desktop
  } else if (currentScreenSize === 'desktop' && mobile) { // fallback if only mobile media exists
    currentMedia = mobile
  } else if (currentScreenSize === 'mobile' && mobile) {
    currentMedia = mobile
  } else if (currentScreenSize === 'mobile' && desktop) { // fallback if only desktop media exists
    currentMedia = desktop
  } else {
    return null
  }

  if (currentMedia.type === 'video') {
    const {videoSrc, thumbnail} = currentMedia
    return (
      <Player
        url={videoSrc}
        loop={true}
        standalone={true}
        autoplay={true}
        noControls={true}
        muted={true}
        thumbnail={thumbnail}
        className={classNames?.video}
        isVideoObjectCover={true}
      />
    )
  }

  const {image} = currentMedia
  return (
    <LazyImage
      className={classNames?.image}
      {...image}
    />
  )
}
